<template>
  <div
    v-if="isVisible"
    class="modal-popup custom-modal"
    :class="[
      {
        show: isVisible,
        'modal-xs': size === 'xs',
        'modal-sm': size === 'sm',
        'modal-md': size === 'md',
        'modal-lg': size === 'lg',
        'modal-xl': size === 'xl',
      },
      customClass,
    ]"
    @click="handleOverlayClick"
  >
    <div class="dimed"></div>
    <div class="popup-inner">
      <div v-if="title || $slots.header" class="popup-header">
        <slot name="header">
          <h3 class="popup-title">{{ title }}</h3>
        </slot>
      </div>

      <div class="popup-body">
        <slot>
          <!-- 기본 컨텐츠 없음 - 부모에서 커스텀 -->
        </slot>
      </div>

      <div v-if="$slots.footer || showDefaultFooter" class="popup-footer">
        <slot name="footer">
          <div class="btn-group">
            <button v-if="showCancel" class="btn btn-md btn-outline-default btn-cancel" @click="handleCancel">
              {{ cancelText }}
            </button>
            <button class="btn btn-md btn-primary btn-confirm" @click="handleConfirm">
              {{ confirmText }}
            </button>
          </div>
        </slot>
      </div>
    </div>
  </div>
</template>

<script setup>
// Props 정의
const props = defineProps({
  isVisible: {
    type: Boolean,
    default: false,
  },
  title: {
    type: String,
    default: "",
  },
  size: {
    type: String,
    default: "sm",
    validator: (value) => ["xs", "sm", "md", "lg", "xl"].includes(value),
  },
  confirmText: {
    type: String,
    default: "확인",
  },
  cancelText: {
    type: String,
    default: "취소",
  },
  showCancel: {
    type: Boolean,
    default: true,
  },
  showDefaultFooter: {
    type: Boolean,
    default: true,
  },
  customClass: {
    type: String,
    default: "",
  },
});

// Emits 정의
const emit = defineEmits(["confirm", "cancel", "close"]);

// Slots 접근
const slots = useSlots();

// 메서드
const handleConfirm = () => {
  emit("confirm");
};

const handleCancel = () => {
  emit("cancel");
};

const handleOverlayClick = (event) => {
  if (event.target === event.currentTarget) {
    emit("close");
  }
};

// Body 스크롤 제어 함수들 - SSR 안전하게 처리
const disableBodyScroll = () => {
  // 클라이언트 환경에서만 실행
  if (import.meta.client && typeof window !== "undefined" && document) {
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    document.documentElement.style.paddingRight = `${scrollbarWidth}px`;
    document.documentElement.classList.add("modal-open");
  }
};

const enableBodyScroll = () => {
  // 클라이언트 환경에서만 실행
  if (import.meta.client && typeof window !== "undefined" && document) {
    document.documentElement.style.paddingRight = "";
    document.documentElement.classList.remove("modal-open");
  }
};

// Watch - isVisible 변경 감지
watch(
  () => props.isVisible,
  (newVal) => {
    if (newVal) {
      disableBodyScroll();
    } else {
      enableBodyScroll();
    }
  }
);

// Lifecycle - 클라이언트에서만 실행
onMounted(() => {
  if (props.isVisible) {
    disableBodyScroll();
  }
});

onBeforeUnmount(() => {
  enableBodyScroll();
});
</script>
